import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";

const MediaGuideSection = ({ mediaGuideSectionData = {} }) => {
  const {
    title = "",
    videoUrl = "",
    description = "",
    showVideo = false,
    backgroundColor = "black",
    image = {},
    textPlacement = ""
  } = mediaGuideSectionData;

  const {
    imageUrl = "",
    src = "",
    url = "",
    alt = "",
    name = "",
  } = image[0]?.fields || {};

  return (
    <section className={`${styles[`wrapper${backgroundColor}`]}`}>
      <div className={styles.container}>
        {title && textPlacement === "Upper" && <h2 className={styles.title}>{title}</h2>}
        {(imageUrl || src || url || videoUrl) && (
          <div className={styles.videoWrapper}>
            {showVideo ? (
              <iframe
                src={videoUrl}
                title="Installation Guide Video"
                allowFullScreen
              />
            ) : (
              <img src={imageUrl || src || url} alt={alt || name} />
            )}
          </div>
        )}
        {title && textPlacement === "Lower" && <h2 className={styles.title}>{title}</h2>}
        {description && (
          <div className={styles.descriptionWrapper}>
            <p className={styles.description}>{description}</p>
          </div>
        )}
        <div className={styles.divider}></div>
      </div>
    </section>
  );
};

MediaGuideSection.propTypes = {
  mediaGuideSectionData: PropTypes.shape({
    title: PropTypes.string,
    videoUrl: PropTypes.string,
    description: PropTypes.string,
    showVideo: PropTypes.bool,
    backgroundColor: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
  }),
};

export default MediaGuideSection;
